import { useIsNewSessionListEnabled } from '@/features/flags';
import { ability, ACTIONS, PERMISSION_SUBJECTS } from '@/helpers/casl/ability';

/**
 * Whether the current user may create a session from the plain "New session" action.
 *
 * Needs TEAM_OTHERS_SESSION_CREATE only when creating for the reviewed member (old list while
 * reviewing). The new list is always a self-create, so it needs only SESSION_CREATE.
 */
export const useCanCreateSession = (isReviewingOtherUser: boolean): boolean => {
  const isNewSessionListEnabled = useIsNewSessionListEnabled();

  const createsForReviewedMember = !isNewSessionListEnabled && isReviewingOtherUser;
  return ability.can(
    ACTIONS.ACCESS,
    createsForReviewedMember
      ? PERMISSION_SUBJECTS.TEAM_OTHERS_SESSION_CREATE
      : PERMISSION_SUBJECTS.SESSION_CREATE
  );
};
